const DOWNLOAD_PATH = '/api/downloads/artwork-images';

/**
 * Download URLs contain a short-lived bearer credential. Drop telemetry that
 * contains that URL, including SDK request/span/breadcrumb nesting, rather
 * than shipping a copy of its query to a third party. Ordinary events stay
 * unchanged. Audit records contain counts/identity, never the URL.
 */
export function containsOriginalDownloadUrl(value: unknown, visited = new WeakSet<object>()): boolean {
  if (typeof value === 'string') return value.includes(DOWNLOAD_PATH);
  if (!value || typeof value !== 'object' || visited.has(value)) return false;
  visited.add(value);
  return Object.values(value).some(child => containsOriginalDownloadUrl(child, visited));
}
export function omitOriginalDownloadTelemetry<T>(event: T): T | null {
  return containsOriginalDownloadUrl(event) ? null : event;
}
